export const max = <T>(values: T[], comparator: (value: T) => number): T => {
  return values.sort((x, y) => comparator(y) - comparator(x))[0];
};
